// import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import * as CurrencyCodes from 'self-service-api/constants/CurrencyCodes';
import { useAppSelector } from '../reducers';
import { isAppAuthSelector } from './AuthSelectors'; // import { isAppAuthSelector } from './ConfigSelectors';

export const allPromotionsSelector = ({
  promotions
}) => promotions;
export const allProductsSelector = ({
  abstractedProducts: {
    productMap
  }
}) => productMap;

const _rawProductListSelector = ({
  abstractedProducts: {
    rawProductList
  }
}) => rawProductList;

export const skuMapSelector = ({
  abstractedProducts: {
    skuMap
  }
}) => skuMap;
export const apiNameToProductIdSelector = ({
  abstractedProducts: {
    apiNameToProductId
  }
}) => apiNameToProductId;

const productLineLevelToProductIdSelector = ({
  abstractedProducts: {
    productLineLevelToProductId
  }
}) => productLineLevelToProductId;

export const requiredOnboardingSelector = state => {
  const {
    requiredOnboarding
  } = state;
  return requiredOnboarding;
};
export const productInventorySelector = ({
  productInventory
}) => productInventory;
export const seatsInventorySelector = ({
  seatsInventory
}) => seatsInventory;
export const featuresSelector = ({
  features
}) => features;
export const compareSelector = ({
  compare
}) => compare;
export const businessObjectivesSelector = ({
  businessObjectives
}) => businessObjectives;
export const activeTrialsSelector = ({
  activeTrials
}) => activeTrials;
export const companyDetailsSelector = ({
  companyDetails
}) => companyDetails;
export const productDataSelector = createSelector([allProductsSelector, skuMapSelector, apiNameToProductIdSelector, productLineLevelToProductIdSelector, _rawProductListSelector], (productMap, skuMap, apiNameToProductId, productLineLevelToProductId, rawProductList) => ({
  productMap,
  skuMap,
  apiNameToProductId,
  productLineLevelToProductId,
  rawProductList
}));

const _customerCurrencyCodeSelector = ({
  customerCurrencyCode
}) => customerCurrencyCode;

const _activeCurrencySelector = state => {
  const {
    activeCurrencyCode
  } = state;

  const customerCurrencyCode = _customerCurrencyCodeSelector(state);

  if (customerCurrencyCode) {
    return customerCurrencyCode;
  }

  if (!CurrencyCodes[activeCurrencyCode]) return CurrencyCodes.USD;
  return activeCurrencyCode;
};

export const gatesSelector = state => {
  if (isAppAuthSelector(state)) {
    const {
      auth: {
        gates,
        user: {
          scopes = []
        }
      }
    } = state;
    return [...gates, ...scopes];
  }

  const {
    publicFeatureFlags
  } = state;
  const featureFlagKeys = Object.keys(publicFeatureFlags);
  return featureFlagKeys.filter(key => {
    return publicFeatureFlags[key] === true;
  });
};
export const recommendedHubSelector = ({
  recommendedHub
}) => {
  return recommendedHub;
};
/**
 * createSelector can only combine a maximum of 12 selectors on the current version of
 * reselect (2.16).  To bypass this, transformStateOverflow handles the additional reducers.
 */

export const transformState = createSelector([productDataSelector, allPromotionsSelector, _activeCurrencySelector, requiredOnboardingSelector, gatesSelector, featuresSelector, compareSelector, productInventorySelector, businessObjectivesSelector, seatsInventorySelector, activeTrialsSelector, recommendedHubSelector], (productData, promotions, currencyCode, requiredOnboarding, gates, features, compare, productInventory, businessObjectives, seatsInventory, activeTrials, recommendedHub) => ({
  productData,
  promotions,
  currencyCode,
  requiredOnboarding,
  gates,
  features,
  compare,
  productInventory,
  businessObjectives,
  seatsInventory,
  activeTrials,
  recommendedHub
}));
export const transformStateOverflow = createSelector([companyDetailsSelector], companyDetails => ({
  companyDetails
}));
export const usePricingLibSelector = selector => useAppSelector(state => selector(Object.assign({}, transformState(state), {}, transformStateOverflow(state))));